import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { usePlayer } from '../../../PlayerProvider';
import { DefaultButton } from '../DefaultButton';
import { VolumeControlIcon } from './VolumeControlIcon';

export function VolumeControlButton({ ...forwardingProps }) {
  const { volume, setVolume } = usePlayer();
  const [savedVolume, setSavedVolume] = useState(0);

  const onClick = useCallback(() => {
    if (volume > 0) {
      setSavedVolume(volume);
      setVolume(0);
    } else {
      setVolume(savedVolume || 0.5);
      setSavedVolume(0);
    }
  }, [savedVolume, setVolume, volume]);

  return (
    <VolumeControlButtonComponent
      {...forwardingProps}
      aria-label="Volume"
      onClick={onClick}
    >
      <VolumeControlIcon />
    </VolumeControlButtonComponent>
  );
}

export const VolumeControlButtonComponent = styled(DefaultButton)`
  margin-left: 0;
`;
